import React, { useEffect, useState } from 'react';


import Header from "../../components/Header";
import Footer from "../../components/Footer";
import DataTableExchange from './DatatableExchange';

function ExchangeRates() {

return ( <>
        <Header />
        <section className="sectionPageContent">
            <h1>
                ADMIN EXCHANGE RATES
            </h1>    
        </section>        
        <div>
            <DataTableExchange />
        </div>
        <Footer />
        </>    );
}

export default ExchangeRates;